export default __webpack_public_path__ + "static/planning-poker-voting-86185d2c1ead1bf3986710528ba1524e.mp4";